import { render, staticRenderFns } from "./WithdrawForm.vue?vue&type=template&id=2f0b34d1&"
import script from "./WithdrawForm.vue?vue&type=script&lang=js&"
export * from "./WithdrawForm.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WithdrawForm.vue"
export default component.exports